import Router from 'vue-routes-generator'
import Main from './Main'
export default {
	install: (Vue) => {
		Router.route('/main').child('gestion-tarifas', {
			name: 'Gestión de tarifas',
			component: Main
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-tarifas/vue/index.js